// generated by the plop

import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { append, insertItem, patch, updateItem } from '@ngxs/store/operators';
import { PROGRESS_STATUSES } from 'symbols';
import { DebtService } from '../../services/debt.service';
import {
  ClearScrollPositionDebtList, CreatedDebtByWS,
  GetDebtList,
  GetDebtListError,
  GetDebtListSuccess, SetLastOpenedDebtId, UpdatedDebtByWS,
  UpdateScrollPositionDebtList
} from './debt-list.actions';
import { DEBT_LIST_STATE_DEFAULT, DebtListStateModel } from './debt-list.model';

@State({ name: 'DebtList', defaults: DEBT_LIST_STATE_DEFAULT })
@Injectable()
export class DebtListState {

  constructor(private debtService: DebtService, private store: Store) {
  }


  @Selector()
  static debtList(state: DebtListStateModel): DebtListStateModel['debtList'] {
    return state.debtList;
  }

  @Selector()
  static loadDebtListStatus(state: DebtListStateModel): DebtListStateModel['loadDebtListStatus'] {
    return state.loadDebtListStatus;
  }

  @Selector()
  static lastOpenedDocId(state: DebtListStateModel): DebtListStateModel['lastOpenedDocId'] {
    return state.lastOpenedDocId;
  }

  @Selector()
  static scrollPosition(state: DebtListStateModel): DebtListStateModel['scrollPosition'] {
    return state.scrollPosition;
  }

  @Action(GetDebtList)
  getDebtList(ctx: StateContext<DebtListStateModel>, { filter, lazy }: GetDebtList): void {
    if (lazy) {
      const next = ctx.getState().debtList?.links?.next;
      if (next) {
        ctx.patchState({
          loadDebtListStatus: PROGRESS_STATUSES.IN_PROGRESS
        });
        this.debtService.getDebtListLazy(next).subscribe({
          next: debts => ctx.dispatch(new GetDebtListSuccess(debts, lazy)),
          error: error => ctx.dispatch(new GetDebtListError(error))
        });
      }
    } else {
      ctx.patchState({
        loadDebtListStatus: PROGRESS_STATUSES.IN_PROGRESS
      });
      this.debtService.getDebtList(filter).subscribe({
        next: debts => ctx.dispatch(new GetDebtListSuccess(debts, lazy)),
        error: error => ctx.dispatch(new GetDebtListError(error))
      });
    }
  }

  @Action(GetDebtListSuccess)
  getDebtListSuccess(ctx: StateContext<DebtListStateModel>, { debtList, lazy }: GetDebtListSuccess): void {
    ctx.patchState({
      loadDebtListStatus: PROGRESS_STATUSES.SUCCESS
    });
    if (lazy) {
      ctx.setState(patch({
        debtList: patch({
          data: append([...debtList.data]),
          links: debtList.links,
          meta: debtList.meta
        })
      }));
    } else {
      ctx.patchState({
        debtList
      });

    }
  }

  @Action(GetDebtListError)
  getDebtListError(ctx: StateContext<DebtListStateModel>, { error }: GetDebtListError): void {
    ctx.patchState({
      loadDebtListStatus: PROGRESS_STATUSES.FAIL
    });
  }


  @Action(ClearScrollPositionDebtList)
  clearScrollPositionDebtList(ctx: StateContext<DebtListStateModel>): void {
    ctx.patchState({ scrollPosition: 0 });
  }

  @Action(UpdateScrollPositionDebtList)
  updateScrollPosition(ctx: StateContext<DebtListStateModel>, { position }: UpdateScrollPositionDebtList): void {
    ctx.patchState({ scrollPosition: position });
  }

  @Action(SetLastOpenedDebtId)
  setLastOpenedDocId(ctx: StateContext<DebtListStateModel>, { debtId }: SetLastOpenedDebtId): void {
    ctx.patchState({ lastOpenedDocId: debtId });
  }

  @Action(UpdatedDebtByWS)
  updatedDebtBuWS(ctx: StateContext<DebtListStateModel>, { debt }: UpdatedDebtByWS): void {
    ctx.setState(patch({
      debtList: patch({
        data: updateItem(o => o?.id === debt.id, debt)
      })
    }));
  }

  @Action(CreatedDebtByWS)
  createdDebtByWS(ctx: StateContext<DebtListStateModel>, { debt }: CreatedDebtByWS): void {
    ctx.setState(patch({
      debtList: patch({
        data: insertItem(debt, 0),
        meta: patch({
          totalItems: ctx.getState().debtList?.meta?.totalItems + 1
        })
      })
    }));

  }
}


